const STUDIO_PERIOD_SELECTION_PREFIX = 'studio_period_selection_v1'
const GLOBAL_PERIOD_SELECTION_KEY = 'global_period_selection_v1'

const getKey = (studioId: number) => `${STUDIO_PERIOD_SELECTION_PREFIX}:${studioId}`

export function getStudioPeriodSelection(studioId: number): number | null {
  if (!studioId || Number.isNaN(studioId)) return null
  try {
    const raw = sessionStorage.getItem(getKey(studioId))
    if (!raw) return null
    const parsed = Number(raw)
    return Number.isFinite(parsed) ? parsed : null
  } catch {
    return null
  }
}

export function setStudioPeriodSelection(studioId: number, periodId: number): void {
  if (!studioId || Number.isNaN(studioId) || !periodId || Number.isNaN(periodId)) return
  try {
    sessionStorage.setItem(getKey(studioId), String(periodId))
  } catch {
    // ignore storage errors
  }
}

export function getGlobalPeriodSelection(): number | null {
  try {
    const raw = sessionStorage.getItem(GLOBAL_PERIOD_SELECTION_KEY)
    if (!raw) return null
    const parsed = Number(raw)
    return Number.isFinite(parsed) ? parsed : null
  } catch {
    return null
  }
}

export function setGlobalPeriodSelection(periodId: number): void {
  if (!periodId || Number.isNaN(periodId)) return
  try {
    sessionStorage.setItem(GLOBAL_PERIOD_SELECTION_KEY, String(periodId))
  } catch {
    // ignore storage errors
  }
}
